import React from "react";
import RegisterGroup from "../../components/RegisterGroup";
import HeaderDrawer from "../../../common/components/HeaderDrawer";

const RegisterGroupScreen = (props) => {
  return (
    <HeaderDrawer name="Cadastrar novo grupo de usuário">
      <RegisterGroup {...props} />
    </HeaderDrawer>
  );
};

export default RegisterGroupScreen;
